import React, { useEffect, useState } from 'react';
import { MenuItem, Select, SelectProps, SxProps, Typography } from '@mui/material';
import { useQueryClient } from 'react-query';
import { LinearProgress, useAuthProvider } from 'react-admin';
import { Resources } from '@/src/shared/constants/resources';
import { UserFields } from '@/src/shared/constants/users';
import { useGetIdentity } from 'ra-core';
import { LLButton } from '@/components-library';
import { useGetUsersByIds } from '@/src/shared/hooks/api/useGetUsersByIds';
import { useImpersonatingUid } from '@/src/shared/hooks/useImpersonatingUid';

type CommonEmployerChooseInputProps = {
  sx?: SxProps;
} & SelectProps;

const CommonEmployerChooseInput = (props: CommonEmployerChooseInputProps) => {
  const sx = {};
  const { identity, refetch } = useGetIdentity();
  const [isLoading, setIsLoading] = useState(false);
  const queryClient = useQueryClient();
  const auth = useAuthProvider();
  const impersonatingId = useImpersonatingUid([identity?.[UserFields.Uid]]);
  const { data: clubAdminUsers } = useGetUsersByIds(identity?.[UserFields.ClubAdminUids]);

  async function onChange(e) {
    try {
      setIsLoading(true);
      await auth.loginClub(e.target.value);
      await queryClient.invalidateQueries(Resources.Profiles);
      await refetch();
    } finally {
      setIsLoading(false);
    }
  }

  async function onSwitchBack() {
    try {
      setIsLoading(true);
      await auth.logoutClub();
      await queryClient.invalidateQueries(Resources.Profiles);
      await refetch();
    } finally {
      setIsLoading(false);
    }
  }

  if (isLoading) return <LinearProgress color={'primary'} />;

  if (impersonatingId)
    return (
      <>
        <LLButton sx={{ width: '130px' }} variant="text" onClick={onSwitchBack}>
          Switch back
        </LLButton>
        <Typography sx={{ mb: 0.5, ml: 1 }}>{identity?.[UserFields.Username]}</Typography>{' '}
      </>
    );

  if (!clubAdminUsers?.data?.length)
    return <Typography sx={{ mb: 0.5, ml: 1 }}>{identity?.[UserFields.Username]}</Typography>;

  return (
    <Select
      required
      variant="standard"
      value={identity?.[UserFields.Uid]}
      onChange={onChange}
      {...props}
      sx={[
        {
          '& .MuiSelect-select': { backgroundColor: 'unset' },
          '&:before, &:after': { border: 'none !important' },
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    >
      <MenuItem disabled value={identity?.[UserFields.Uid]}>
        {identity?.[UserFields.Username]}
      </MenuItem>
      {/*{employeeUsers?.map((employee) => (*/}
      {/*  <MenuItem key={employee[UserFields.Uid]} value={employee[UserFields.Uid]}>*/}
      {/*    {employee[UserFields.Username]}*/}
      {/*  </MenuItem>*/}
      {/*))}*/}
      {clubAdminUsers?.data?.map((employer) => (
        <MenuItem key={employer[UserFields.Uid]} value={employer[UserFields.Uid]}>
          {employer[UserFields.Username]}
        </MenuItem>
      ))}
    </Select>
  );
};

export default CommonEmployerChooseInput;
